import {Box, Grid} from '@mantine/core';
import React from 'react';

import FieldLabel from 'ui-library/inputs/FieldLabel';
import NumericInput from 'ui-library/inputs/NumericInput';
import {NumericInputChangeEvent} from 'util/Types';

import {
  ConcentrationLayerData,
  DilutionSettings as DilutionSettingsType,
} from '../concentration-layers/machine/ConcentrationLayerMachine';
import PatternAssignmentIntegerInput from '../pattern-controls/PatternAssignmentIntegerInput';
import PatternDirectionDropdown from '../pattern-controls/PatternDirectionDropdown';

interface DilutionSettingsProps {
  activeLayer: ConcentrationLayerData;
  onUpdateLayerDilutionSettings: (layerId: string, settings: Partial<DilutionSettingsType>) => void;
}

export default function DilutionSettings({
  activeLayer,
  onUpdateLayerDilutionSettings,
}: DilutionSettingsProps): JSX.Element {
  const {dilutionFactor, dilutionDirection, replicates, replicateDirection} = activeLayer.dilutionSettings;
  return (
    <Box>
      <Grid>
        <Grid.Col span={6}>
          <FieldLabel label="Dilution factor" isRequired={true} />
          <NumericInput
            value={dilutionFactor}
            min={0}
            onChange={(e: NumericInputChangeEvent) => {
              onUpdateLayerDilutionSettings(activeLayer.layerId, {
                dilutionFactor: e.target.numericValue,
              });
            }}
            isDisabled={false}
            required={false}
            validateInteger={false}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <PatternDirectionDropdown
            label="Dilution direction"
            selectedDirection={dilutionDirection}
            onSelectDirection={(direction) => {
              onUpdateLayerDilutionSettings(activeLayer.layerId, {
                dilutionDirection: direction,
              });
            }}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={6}>
          <PatternAssignmentIntegerInput
            label="Replicates"
            isRequired={true}
            value={replicates}
            onChange={(value) => {
              onUpdateLayerDilutionSettings(activeLayer.layerId, {
                replicates: value,
              });
            }}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <PatternDirectionDropdown
            label="Replicate direction"
            selectedDirection={replicateDirection}
            onSelectDirection={(replicateDirection) => {
              onUpdateLayerDilutionSettings(activeLayer.layerId, {
                replicateDirection,
              });
            }}
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
}
